"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const ExpandingGridLayout_1 = tslib_1.__importDefault(require("../expanding/ExpandingGridLayout"));
class WarningExpandingGridLayout extends ExpandingGridLayout_1.default {
    constructor(gridConfig) {
        super(gridConfig);
        this.dataToWarning = new Map();
    }
    addWarnings(data, warnings) {
        this.dataToWarning.set(data, warnings);
    }
    clearWarnings() {
        /* this.tableRowToWarningRowMap.forEach(((value, key) => {
            const tr = value.parentElement;
            if (tr) {
                const tbody = tr.parentElement;
                if (tbody) {
                    tbody.removeChild(tr);
                    key.classList.remove("has-warning-row");
                }
            }
        }));*/
        this.dataToWarning.clear();
    }
    postRender() {
        super.postRender();
        this.dataToWarning.forEach((gridWarningEntries, data) => {
            if (gridWarningEntries.length) {
                const domRow = this.data2DataRow(data);
                const warningRowTD = this.insertWarningRowAndReturnTd(domRow);
                for (const gridWarningEntry of gridWarningEntries) {
                    const div = document.createElement("div");
                    div.textContent = gridWarningEntry.text;
                    div.classList.add(gridWarningEntry.severity);
                    warningRowTD.appendChild(div);
                }
            }
        });
    }
    insertWarningRowAndReturnTd(domRow) {
        const warningRow = this.table.insertRow(domRow.rowIndex - 1);
        warningRow.classList.add("grid-warning-row");
        domRow.classList.add("has-warning-row");
        const detailRow = warningRow.rowIndex - 1;
        const td = this.table.setColSpan(detailRow, 0, this.gridConfig.getNumberOfColumns());
        this.table.setColumnStyle(detailRow, 0, "first last");
        return td;
    }
}
exports.default = WarningExpandingGridLayout;
//# sourceMappingURL=WarningExpandingGridLayout.js.map